import styled from '@emotion/styled';
import { Button, Modal, Text } from '@innovationdepartment/proxima-ui';
import type { Brand } from 'types/stores/brand-store';
import ButtonGroup from 'ui/ButtonGroup';

type BrandActionsConfirmLockUnlockModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  brand: Brand;
  isLocked: boolean;
};

const TextWrapper = styled.div`
  padding: 8px 0;
  margin-bottom: 24px;
  max-width: 480px;
`;

const BrandActionsConfirmLockUnlockModal = (props: BrandActionsConfirmLockUnlockModalProps) => {
  const { brand, isLocked, onClose, onConfirm, open } = props;

  return (
    <Modal noPadding={false} open={open} title={`${isLocked ? 'Unlock' : 'Lock'} brand`}>
      <TextWrapper>
        <Text variant="body2Medium">
          Are you sure you want to {isLocked ? 'unlock' : 'lock'} the brand{' '}
          <strong>{brand.name}</strong>?
          <br />
          {isLocked ? (
            <>
              Unlocking this brand enables editing and allows it to be used for creating new
              audiences.
              <br />
              <strong>Note:</strong> if the brand is not associated with a plan or is designated as
              managed, it may be automatically locked again.
            </>
          ) : (
            'Locking this brand disables editing and prevents it from being used for creating new audiences.'
          )}
        </Text>
      </TextWrapper>
      <ButtonGroup>
        <Button size="small" variant="outlined" label="Cancel" onClick={onClose} />
        <Button
          size="small"
          color="error"
          label={isLocked ? 'Unlock' : 'Lock'}
          onClick={onConfirm}
        />
      </ButtonGroup>
    </Modal>
  );
};

export default BrandActionsConfirmLockUnlockModal;
